import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

// Body de /bonusqr/public/qr/{code}/redeem/ - todos los campos son requeridos
export interface BonoPacienteEstaticoBody {
  cc_type: number;
  cc: string;
  first_name: string;
  last_name: string;
  country_code: string;
  cell: string;
  specialty_id: string;
  email: string;
}

// Body de /bonusqr/public/dynamic-qr/{token}/redeem/ - cc_type y country_code
// van implícitos (Colombia / Cédula) porque el formulario no los muestra al paciente
export interface BonoPacienteDinamicoBody {
  cc_type: number;
  cc: string;
  first_name: string;
  last_name: string;
  country_code: string;
  cell: string;
  specialty_id: string;
  email: string;
}

@Injectable({ providedIn: 'root' })
export class BonusqrService {
  constructor(private _http: HttpClient) {}

  // === Paciente - QR estático ===
  verifyStaticQr(code: string): Observable<any> {
    return this._http.get(`${environment.Api_bonusqr_public_qr}${code}/`);
  }

  redeemStaticQr(code: string, body: BonoPacienteEstaticoBody): Observable<any> {
    return this._http.post(`${environment.Api_bonusqr_public_qr}${code}/redeem/`, body);
  }

  // === Paciente - QR dinámico ===
  verifyDynamicQr(token: string): Observable<any> {
    return this._http.get(`${environment.Api_bonusqr_public_dynamic_qr}${token}/`);
  }

  redeemDynamicQr(token: string, body: BonoPacienteDinamicoBody): Observable<any> {
    return this._http.post(`${environment.Api_bonusqr_public_dynamic_qr}${token}/redeem/`, body);
  }

  // === Médico / Asistente ===
  generateDynamicQr(): Observable<any> {
    return this._http.post(environment.Api_bonusqr_generate_dynamic, {});
  }

  // === Comercial / Admin ===
  listBonusQr(filters?: { is_active?: boolean; medic_id?: number }): Observable<any> {
    let params = new HttpParams();
    if (filters) {
      if (filters.is_active !== undefined && filters.is_active !== null) {
        params = params.set('is_active', String(filters.is_active));
      }
      if (filters.medic_id !== undefined && filters.medic_id !== null) {
        params = params.set('medic_id', String(filters.medic_id));
      }
    }
    return this._http.get(environment.Api_bonusqr_admin, { params });
  }

  createBonusQr(body: { medic_id: number; assistant_id?: number; label?: string }): Observable<any> {
    return this._http.post(environment.Api_bonusqr_admin, body);
  }

  toggleBonusQr(code: string, active: boolean): Observable<any> {
    return this._http.post(`${environment.Api_bonusqr_admin}${code}/toggle/`, { active });
  }

  reassignBonusQr(
    code: string,
    body: { new_medic_id?: number; new_assistant_id?: number; new_label?: string }
  ): Observable<any> {
    return this._http.post(`${environment.Api_bonusqr_admin}${code}/reassign/`, body);
  }

  getPerformance(code: string): Observable<any> {
    return this._http.get(`${environment.Api_bonusqr_admin}${code}/performance/`);
  }

  // === Admin (resumen global) ===
  getSummary(): Observable<any> {
    return this._http.get(`${environment.Api_bonusqr_admin}summary/`);
  }

  // === Referidos ===
  getGlobalReferrals(page?: number): Observable<any> {
    let params = new HttpParams();
    if (page) {
      params = params.set('page', String(page));
    }
    return this._http.get(`${environment.Api_bonusqr_admin}referrals/`, { params });
  }

  getReferralsByCode(code: string, page?: number): Observable<any> {
    let params = new HttpParams();
    if (page) {
      params = params.set('page', String(page));
    }
    return this._http.get(`${environment.Api_bonusqr_admin}${code}/referrals/`, { params });
  }
}
